/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TemplateDetail,
    TemplateDetailFromJSON,
    TemplateDetailFromJSONTyped,
    TemplateDetailToJSON,
} from './TemplateDetail';

/**
 * GET /templates/{template_id}
 * @export
 * @interface GetTemplateDetailSuccessResponse
 */
export interface GetTemplateDetailSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetTemplateDetailSuccessResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetTemplateDetailSuccessResponse
     */
    message: string;
    /**
     * 
     * @type {TemplateDetail}
     * @memberof GetTemplateDetailSuccessResponse
     */
    data: TemplateDetail;
}

export function GetTemplateDetailSuccessResponseFromJSON(json: any): GetTemplateDetailSuccessResponse {
    return GetTemplateDetailSuccessResponseFromJSONTyped(json, false);
}

export function GetTemplateDetailSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTemplateDetailSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': TemplateDetailFromJSON(json['data']),
    };
}

export function GetTemplateDetailSuccessResponseToJSON(value?: GetTemplateDetailSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': TemplateDetailToJSON(value.data),
    };
}

